// extracted by mini-css-extract-plugin
export default {"TopAppBar":"topAppBar_TopAppBar__NDC4N","title":"topAppBar_title__tq0A7"};